import {
    Box,
    Typography,
} from '@mui/material'
import Banner1 from '../../../assets/app/home/home-banner1.png'
import Banner2 from '../../../assets/app/home/home-banner2.png'
import Banner3 from '../../../assets/app/home/home-banner3.png'
import Banner4 from '../../../assets/app/home/home-banner4.png'
import { Image } from 'antd'
import { MOTORLOAN_LINK, ROOT_PATH } from '../../../common/config'
import { useTranslation } from 'react-i18next'
import { ScreenWidthPort } from '../../../ScreenWidthContext'

export const SMAppHomeBanner: React.FC = () => {
    const { screenWidth } = ScreenWidthPort()

    const { t } = useTranslation()

    // 打开新页面
    const goToNewPage = (path: String, index: number) => {
      if (path !== '') {
        if (index === 3) {
          window.open(path)
        } else {
          window.location.replace(ROOT_PATH + path)
        }    
      }
    }

    const data = [
        {
            'title': t('t18')+' '+t('t19'),
            'content': t('t26'),
            'image': Banner1,
            'link': '/motorcycle-financing',
        },
        {
            'title': t('t20')+' '+t('t21'),
            'content': t('t27'),
            'image': Banner2,
            'link': '/personal-loan',
        },
        {
            'title': t('t22')+' '+t('t23'),
            'content': t('t28'),
            'image': Banner3,
            'link': '/motor-vehicle',
        },
        {
            'title': t('t24')+' '+t('t25'),
            'content': t('t29'),
            'image': Banner4,
            'link': MOTORLOAN_LINK,
        },
    ]

    const renderBannerItem = (index: number) => {
        return (
            <Box key={index} sx={{
                position: 'relative',
                padding: '0px',
                height: (screenWidth * 560 / 375),
            }}>
                <Box >
                    <Image width={'100%'} height={(screenWidth * 560 / 375)} src={data[index]['image']} alt='' preview={false}></Image>
                </Box>

                <Box sx={{
                    width: '100%',
                    height: (screenWidth * 560 / 375),
                    position: 'absolute',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'end',
                    left: '0px',
                    bottom: '0px',
                    paddingBottom: '80px',
                    paddingLeft: '24px',
                    paddingRight: '24px',
                    backgroundColor: index === 1 ? 'transparent' : 'rgba(0,0,0,0.3)', 
                }}
                onClick={()=> goToNewPage(data[index]['link'], index)}
                >
                    <Typography fontSize={32} fontWeight={700} color={'#FFFFFF'}>
                        {data[index]['title']}
                    </Typography>
                    <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'}>
                        {data[index]['content']}
                    </Typography>
                </Box>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box sx={{
            width: '100%',
            height: '100%',
        }}>
            {/* banner */}
            {data.map((item, index) => (renderBannerItem(index)))}
        </Box>
    )
}

// ======================= EXPORT
export default SMAppHomeBanner
